"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BestLabel = _interopRequireDefault(require("./BestLabel"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RightLabel = _styledComponents["default"].span.attrs(function () {
  return {
    className: "ml-2"
  };
}).withConfig({
  displayName: "BestLabelWithRight__RightLabel",
  componentId: "sc-7te8me-0"
})(["color:", ";font-weight:400;font-size:0.875rem;"], function (props) {
  return props.styles.color;
});

var BestLabelWithRight = function BestLabelWithRight(_ref) {
  var name = _ref.name,
      label = _ref.label,
      rightLabel = _ref.rightLabel,
      styles = _ref.styles,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    color: Theme["mlb-red"]
  };

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  return _react["default"].createElement("div", {
    className: "d-flex"
  }, _react["default"].createElement(_BestLabel["default"], {
    "for": name,
    required: required
  }, label), rightLabel && _react["default"].createElement(RightLabel, {
    styles: CompStyles
  }, " ", rightLabel, " "));
};

BestLabelWithRight.propTypes = {
  /** name the label is for */
  name: _propTypes["default"].string.isRequired,

  /** base label */
  label: _propTypes["default"].string.isRequired,

  /** what the right label should say */
  rightLabel: _propTypes["default"].string,

  /** styles to override the right label */
  styles: _propTypes["default"].object,

  /** if the label is required */
  required: _propTypes["default"].bool
};
BestLabelWithRight.defaultProps = {
  rightLabel: "",
  styles: {},
  required: false
};
var _default = BestLabelWithRight;
exports["default"] = _default;